import vuetify from "@/plugins/vuetify";
import { corBarraClaro } from "@/plugins/corAmbiente";
import {
  lerTemaSalvo,
  mediaTemaEscuro,
  salvarTema,
  sistemaPrefereEscuro,
  temaInicialEscuro,
} from "@/plugins/temaPreferencia";

// Em develop/homologação a barra do navegador acompanha a cor do ambiente.
const COR_BARRA_CLARO = corBarraClaro();
const COR_BARRA_ESCURO = "#121018";

export function temaEscuroAtivo() {
  return vuetify.framework.theme.dark;
}

/** Aplica o tema no Vuetify, nas variáveis CSS (classe no <html>) e na barra do navegador. */
export function aplicarTema(escuro) {
  vuetify.framework.theme.dark = escuro;
  document.documentElement.classList.toggle("tema-escuro", escuro);

  let meta = document.querySelector('meta[name="theme-color"]');
  if (!meta) {
    meta = document.createElement("meta");
    meta.name = "theme-color";
    document.head.appendChild(meta);
  }
  meta.content = escuro ? COR_BARRA_ESCURO : COR_BARRA_CLARO;
}

/** 'claro' | 'escuro' grava a escolha; null volta a seguir o sistema operacional. */
export function definirTema(tema) {
  salvarTema(tema);
  aplicarTema(tema ? tema === "escuro" : sistemaPrefereEscuro());
}

/** A escolha salva na conta prevalece sobre a do navegador. */
export function sincronizarTemaComUsuario(user) {
  if (user && (user.tema === "claro" || user.tema === "escuro")) {
    definirTema(user.tema);
  }
}

export function iniciarTema() {
  aplicarTema(temaInicialEscuro());

  const media = mediaTemaEscuro();
  if (!media) return;

  const aoMudarSistema = (evento) => {
    if (!lerTemaSalvo()) aplicarTema(evento.matches);
  };
  if (media.addEventListener) {
    media.addEventListener("change", aoMudarSistema);
  } else if (media.addListener) {
    media.addListener(aoMudarSistema);
  }
}
